// Pictogrammes de la messagerie et des notifications : les tracés sont dans le jeu commun
// (composants/Icones.tsx) ; ce fichier garde les noms propres au module et le pictogramme d'une conversation.

import { Icone, type NomIcone } from '../../composants/Icones';

/** Icônes propres à la messagerie et aux notifications, désormais tenues dans le jeu commun. */
export type NomIconeH2 = Extract<NomIcone, 'cloche' | 'trombone' | 'envoyer' | 'cadenas' | 'recherche' | 'citation' | 'groupe' | 'annonce' | 'crise' | 'personne'>;

export function IconeH2({ nom, taille = 18 }: { nom: NomIconeH2; taille?: number }) {
  return <Icone nom={nom} taille={taille} />;
}

const ICONES_OBJETS: Record<string, NomIcone> = {
  livraison: 'camion',
  cargaison: 'camion',
  alerte: 'incident',
  incident: 'incident',
  inspection: 'controle',
  rapprochement: 'document',
};

/** Pictogramme d'une conversation selon son type et l'objet rattaché. */
export function IconeConversation({
  type,
  objetType,
  taille = 20,
}: {
  type: string;
  objetType: string | null;
  taille?: number;
}) {
  if (type === 'service')
    return <Icone nom={(objetType && ICONES_OBJETS[objetType]) || 'liste'} taille={taille} />;
  if (type === 'crise') return <IconeH2 nom="crise" taille={taille} />;
  if (type === 'annonces') return <IconeH2 nom="annonce" taille={taille} />;
  if (type === 'groupe') return <IconeH2 nom="groupe" taille={taille} />;
  return <IconeH2 nom="personne" taille={taille} />;
}
